import React from 'react';

import { type RouteComponentProps, Route, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../helpers/utilities';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';

const KioskList = lazyWithRetry(() => import('./KioskList'));
const KioskTelemetry = lazyWithRetry(() => import('./Telemetry/KioskTelemetry'));
const KioskEdit = lazyWithRetry(() => import('./Edit/KioskEdit'));
const KioskCreate = lazyWithRetry(() => import('./Create/KioskCreate'));
const HomeScreenCustomisation = lazyWithRetry(() => import('./Components/HomeScreenCustomisation'));
const Kiosk = lazyWithRetry(() => import('../SalesChannels/Kiosk'));

type Props = { path: RouteComponentProps['match']['path'] };
type KioskRouteProps = RouteComponentProps<{ id: string }>;

const KioskRoutes = ({ path }: Props) => {
  return (
    <ErrorBoundary identifier="kiosk">
      <Switch>
        <Route
          exact
          path={`${path}/kiosks/homescreen-customisation`}
          render={() => (
            <LazyComponent>
              <HomeScreenCustomisation />
            </LazyComponent>
          )}
        />
        <Route
          exact
          path={`${path}/kiosk`}
          render={() => (
            <LazyComponent>
              <Kiosk />
            </LazyComponent>
          )}
        />
        <Route
          exact
          path={`${path}/kiosks`}
          render={() => (
            <LazyComponent>
              <KioskList />
            </LazyComponent>
          )}
        />
        <Route
          exact
          path={`${path}/kiosks/new`}
          render={() => (
            <LazyComponent>
              <KioskCreate />
            </LazyComponent>
          )}
        />
        <Route
          exact
          path={`${path}/kiosks/:id`}
          render={(routeProps) => (
            <LazyComponent>
              {/* @ts-ignore */}
              <KioskEdit {...routeProps} />
            </LazyComponent>
          )}
        />
        <Route
          exact
          path={`${path}/kiosks/:id/telemetry`}
          render={(routeProps) => (
            <LazyComponent>
              <KioskTelemetry {...routeProps} />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default KioskRoutes;
